import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ApprovalRequestStatus } from './approval-request-status';

@inheritSerialization(AbstractModel)
export class ApprovalRequest extends AbstractModel {
  @autoserialize
  objectId: number;

  @autoserialize
  approvalRequestType: string;

  @autoserialize
  active: boolean;

  @autoserialize
  reviewerUserId: number;

  @autoserialize
  approvalRequestStatus: ApprovalRequestStatus;

  @autoserialize
  rejectionComments: string;

  @autoserializeAs(Date)
  reviewedDate: Date;

  @autoserialize
  requestorNote: string;

  static OnSerialized(instance: ApprovalRequest, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.reviewedDate)) {
      json.reviewedAt = DateUtil.serializeInstant(instance.reviewedDate);
    }
  }

  static OnDeserialized(instance: ApprovalRequest, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['reviewedDate'])) {
      instance.reviewedDate = DateUtil.deserializeInstant(json['reviewedDate']);
    }
  }
}
